import { render, staticRenderFns } from "./decimalElement.vue?vue&type=template&id=64905dfe&scoped=true"
import script from "./decimalElement.vue?vue&type=script&lang=js"
export * from "./decimalElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64905dfe",
  null
  
)

export default component.exports